import React from 'react';
import { useSelector } from 'react-redux';
import { getFlags } from '../redux/selectors';
import { FlagContext } from '../FlagContext';

const ConnectedFlagsProvider: React.FC<{
  children?: React.ReactNode | undefined;
}> = ({ children }) => {
  const flags = useSelector(getFlags);
  return <FlagContext.Provider value={flags}>{children}</FlagContext.Provider>;
};
ConnectedFlagsProvider.displayName = 'ConnectedFlagsProvider';

export default ConnectedFlagsProvider;
